import { ConfluenceLogo } from '@atlaskit/logo';

import { FormattedMessage, defineMessage } from 'react-intl';

import { defineContent, type DefinedContent } from '@post-office/define-content';

import { type JSX } from 'react/jsx-runtime';

export const CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';

export const HAMS_PRODUCT_ID = 'confluence.ondemand';

export const PRODUCT_NAME = 'Confluence';

export const registeredContent: DefinedContent<['appName', 'description']> = defineContent({
	default: {
		appName: {
			id: 'growth.recommendation-confluence.app-switcher-discovery-section.app-name',
			defaultMessage: 'Confluence',
			description:
				'Product name for the Confluence recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-confluence.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Document collaboration',
			role: 'description',
		},
	},
});

export const APP_SWITCHER_PRODUCT_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.default.description} />
);

// go/trailblazers
// TBLZ-858 Product Store - Personal Use Case
export const PRODUCT_LOGO_COMPONENT: JSX.Element = <ConfluenceLogo appearance={'brand'} />;

export const PRODUCT_HEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-confluence.product-heading"
		description="Description of the product"
		defaultMessage="Create one source of truth, for all"
	/>
);

export const PRODUCT_SUBHEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-confluence.product-subheading"
		description="Extra information about the product"
		defaultMessage="Create and link documents like release notes, product requirements, and roadmaps from a single place."
	/>
);

export const PRODUCT_IMAGE_ALT_TEXT: {
	id: string;
	description: string;
	defaultMessage: string;
} = defineMessage({
	id: 'growth.recommendation-confluence.product-alt-text',
	description: 'Alt text for the product image',
	defaultMessage:
		'A document titled quarterly planning. The document has details like mission, scope and a monthly plan.',
});
